import { RETRY_CONFIG } from './apiConfig';

/**
 * Authentication Configuration Constants
 * Centralized configuration for authentication and token management
 */

export const AUTH_CONFIG = {
    // Token refresh interval (in milliseconds)
    // Default: 10 minutes (600000 ms)
    TOKEN_REFRESH_INTERVAL: 1000 * 60 * 10,
    
    // Retry configuration for authentication API calls
    // Imported from common apiConfig for consistency
    RETRY: RETRY_CONFIG,
};

/**
 * Helper to get token refresh interval in different units
 */
export const getTokenRefreshInterval = () => ({
    milliseconds: AUTH_CONFIG.TOKEN_REFRESH_INTERVAL,
    seconds: AUTH_CONFIG.TOKEN_REFRESH_INTERVAL / 1000,
    minutes: AUTH_CONFIG.TOKEN_REFRESH_INTERVAL / (1000 * 60),
});

export const PUBLIC_PATHS = ['/login', '/'];
